module.exports = __webpack_public_path__ + "img/public_2.2b0741ce.jpg";